// extracted by mini-css-extract-plugin
module.exports = {"container":"LegacyLayout_container_2FU7R"};